import { Context, Layer, type Cause, type Effect, type Scope } from "effect";
import type { PanelPlacementFailure } from "./panel-placement-model.ts";

export class PanelPlacementIo extends Context.Service<PanelPlacementIo, {
  readonly find: (container: HTMLElement, id: string) => Effect.Effect<HTMLElement | null, PanelPlacementFailure>;
  readonly place: (mount: HTMLElement, destination: HTMLElement) => Effect.Effect<unknown, PanelPlacementFailure>;
  readonly watch: (mount: HTMLElement, container: HTMLElement, destination: HTMLElement, canRead: () => boolean, report: (failure: PanelPlacementFailure) => void) => Effect.Effect<void, PanelPlacementFailure, Scope.Scope>;
}>()("workerstation/frontend/PanelPlacementIo") {}
export const PanelPlacementIoTest = (io: typeof PanelPlacementIo.Service) => Layer.succeed(PanelPlacementIo, io);
export interface PanelPlacementSession {
  readonly receive: (mount: HTMLElement | null, container: HTMLElement | null, destinationId: unknown) => Effect.Effect<void>;
}
export class PanelPlacements extends Context.Service<PanelPlacements, {
  readonly open: (current: (mount: HTMLElement, container: HTMLElement, destinationId: string) => unknown) => Effect.Effect<PanelPlacementSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<PanelPlacementFailure>[]>;
}>()("workerstation/frontend/PanelPlacements") {}
